import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './ui/Reveal';
import SocialLinks from './ui/SocialLinks';
import { logoHindustanTimes } from '../data/pressOutlets';

const BRAND_STATEMENT = 'ज्योतिषं वेदस्य चक्षु: सत्यं ज्ञानं अनन्तं ब्रह्म ॥';

const EXPLORE = [
  { label: 'Home', to: '/' },
  { label: 'Book a Session', to: '/book' },
  { label: 'Services', to: '/services' },
  { label: 'Seminars', to: '/seminar' },
  { label: 'Blog', to: '/blog' },
  { label: 'About Poonam', to: '/media-profile' },
  { label: 'Contact', to: '/contactUs' },
];

const COMPANY = [
  { label: 'Terms and Conditions', to: '/terms-and-conditions' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Cancellation and Refund', to: '/cancellation-refund-policy' },
];

const linkClass = 'group inline-flex items-center gap-1.5 text-sm text-canvas/75 transition hover:text-canvas';
const Arrow = () => (
  <span className="-translate-x-1 text-amber opacity-0 transition duration-300 group-hover:translate-x-0 group-hover:opacity-100" aria-hidden="true">&rarr;</span>
);

const Footer = () => {
  const backToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="relative overflow-hidden bg-ground-forest text-canvas">
      {/* oversized wordmark behind the content, like an editorial sign-off */}
      <span
        className="pointer-events-none absolute inset-x-0 bottom-0 select-none whitespace-nowrap text-center font-serif text-[9.5vw] font-medium italic leading-[0.8] text-canvas/[0.04]"
        aria-hidden="true"
      >
        Bhavishyavani
      </span>

      <div className="relative mx-auto max-w-container px-5 pb-10 pt-16 sm:px-8 lg:px-10 lg:pt-20">
        <div className="grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-[1.4fr_0.8fr_0.8fr_1fr]">
          <Reveal className="sm:col-span-2 lg:col-span-1">
            <h3 className="font-serif text-3xl italic text-canvas">Bhavishyavani</h3>
            <p className="mt-4 max-w-sm text-sm leading-6 text-canvas/70">
              Private, one-to-one astrology guidance with Acharya Poonam Dutta, for love, career, and life&apos;s turning points.
            </p>
            <p className="mt-5 max-w-sm font-serif text-base italic leading-7 text-amber">{BRAND_STATEMENT}</p>
            <div className="mt-6 inline-flex items-center gap-3 border border-canvas/20 py-2 pl-2 pr-4">
              <span className="flex h-8 items-center bg-white px-2">
                <img src={logoHindustanTimes} alt="Hindustan Times" className="h-4 w-auto" />
              </span>
              <span className="text-[10px] font-semibold uppercase leading-snug tracking-[0.16em] text-canvas/85">Top 10 Astrologers of India</span>
            </div>
          </Reveal>

          <Reveal delay={90}>
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-amber">Explore</h4>
            <ul className="mt-5 space-y-3">
              {EXPLORE.map((item) => (
                <li key={item.label}><Link to={item.to} className={linkClass}>{item.label}<Arrow /></Link></li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={180}>
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-amber">Company</h4>
            <ul className="mt-5 space-y-3">
              {COMPANY.map((item) => (
                <li key={item.label}><Link to={item.to} className={linkClass}>{item.label}<Arrow /></Link></li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={270} className="sm:col-span-2 lg:col-span-1">
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-amber">Stay in touch</h4>
            <a href="mailto:support@bvastro.com" className="mt-5 block text-base text-canvas underline decoration-amber/60 underline-offset-4 transition hover:decoration-amber">
              support@bvastro.com
            </a>
            <p className="mt-2 text-sm leading-6 text-canvas/60">Questions about a booking or a payment? Write to us.</p>
            <SocialLinks tone="dark" showLabels className="mt-6 gap-2.5" />
          </Reveal>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-canvas/15 pt-6 text-xs text-canvas/60 sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; Bhavishyavani {new Date().getFullYear()}. Private online astrology sessions.</p>
          <button
            type="button"
            onClick={backToTop}
            className="group inline-flex items-center gap-2 self-start text-[11px] font-semibold uppercase tracking-[0.2em] text-canvas/80 transition hover:text-amber sm:self-auto"
          >
            Back to top
            <span className="flex h-8 w-8 items-center justify-center rounded-full border border-canvas/25 transition duration-300 group-hover:-translate-y-1 group-hover:border-amber" aria-hidden="true">&uarr;</span>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
